module.exports = __webpack_public_path__ + "static/media/journal.69833285.webp";